var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.97 6.47032C14.1106 6.32987 14.3012 6.25098 14.5 6.25098C14.6988 6.25098 14.8894 6.32987 15.03 6.47032L20.03 11.4703C20.1705 11.6109 20.2493 11.8016 20.2493 12.0003C20.2493 12.1991 20.1705 12.3897 20.03 12.5303L15.03 17.5303C14.9613 17.604 14.8785 17.6631 14.7865 17.7041C14.6945 17.7451 14.5952 17.7671 14.4945 17.7689C14.3938 17.7707 14.2938 17.7522 14.2004 17.7144C14.107 17.6767 14.0222 17.6206 13.951 17.5494C13.8797 17.4781 13.8236 17.3933 13.7859 17.2999C13.7482 17.2065 13.7296 17.1065 13.7314 17.0058C13.7332 16.9051 13.7552 16.8058 13.7962 16.7138C13.8372 16.6218 13.8963 16.539 13.97 16.4703L17.69 12.7503H9.5C8.787 12.7503 7.7 12.9703 6.813 13.6093C5.965 14.2193 5.25 15.2443 5.25 17.0003C5.25 17.1992 5.17098 17.39 5.03033 17.5306C4.88968 17.6713 4.69891 17.7503 4.5 17.7503C4.30109 17.7503 4.11032 17.6713 3.96967 17.5306C3.82902 17.39 3.75 17.1992 3.75 17.0003C3.75 14.7563 4.702 13.2803 5.937 12.3913C7.133 11.5303 8.547 11.2503 9.5 11.2503H17.69L13.97 7.53032C13.8295 7.38969 13.7507 7.19907 13.7507 7.00032C13.7507 6.80157 13.8295 6.61094 13.97 6.47032Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextIcon);
export default __webpack_public_path__ + "static/media/next-icon.0e5c004bfec18764c10f919fe9da8bf2.svg";
export { ForwardRef as ReactComponent };